import { resolveImagePath } from '@/utils/imageResolver';

export function Dream() {
  return (
    <section className="section_dream">
      <div className="dream-wrapper part-one">
        <div className="dream-wrapper_pane">
          <div className="container-main">
            <div className="text-wrapper_callout">
              <p className="p---p_call-out_medium white">
                More than ever before, people are interested in faster and easier travel. What if you had the option to avoid traffic, long lines, and constant rescheduling?
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="dream-wrapper part-two">
        <div className="dream-wrapper_pane">
          <div className="container-main relative">
            {/* Plane animation images for different screen sizes */}
            <img 
              src={resolveImagePath("https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc79a9_Main0012.png")}
              alt="Airplane flying across sky"
              className="mobile_plane-animation absolute inset-0 w-full h-auto object-cover md:hidden animate-plane-mobile"
              loading="lazy"
            />
            <img 
              src={resolveImagePath("https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc79a9_Main0012.png")}
              alt="Airplane flying across sky"
              className="tablet_plane-animation absolute inset-0 w-full h-auto object-cover hidden md:block lg:hidden animate-plane-tablet"
              loading="lazy"
            />
            <img 
              src={resolveImagePath("https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc79a9_Main0012.png")}
              alt="Airplane flying across sky"
              className="plane-animation_desktop absolute inset-0 w-full h-auto object-cover hidden lg:block animate-plane-desktop"
              loading="lazy"
            />
            
            <div className="text-wrapper_callout relative z-10 pt-32 pb-32">
              <p className="p---p_call-out_medium white">
                At Crystal Air, our dream is for the sky to be your only limit. We take the hassle out of traveling through private charter services, allowing you to land closer to your destination on your own schedule.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="dream-wrapper-2">
        <div className="container-main">
          <div className="text-wrapper_callout">
            <p className="p---p_call-out_medium white">
              At Crystal Air, our dream is for the sky to be your only limit. We take the hassle out of traveling through private charter services, allowing you to land closer to your destination on your own schedule.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}